import { render, staticRenderFns } from "./elevatorScreen.vue?vue&type=template&id=4aaafe26"
import script from "./elevatorScreen.vue?vue&type=script&lang=js"
export * from "./elevatorScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports